import { createSlice } from "@reduxjs/toolkit";

// This is constant - Change only if the email changed in Firebase Authentication
// Add new user if any new one is added
const authenticatedUsers = [
	{
		email: "bhuvan243@gmail.com",
		displayName: "Bhuvaneshwaran",
	},
	{
		email: "judahprecious.j@gmail.com",
		displayName: "Chennai Godown",
	},
	{
		email: "preciousgarments2021@gmail.com",
		displayName: "Madurai Godown",
	},
];

// ─── Helpers ──────────────────────────────────────────────────────────────────

const LS_KEY = "auth_user";

const saveToLocalStorage = (user) => {
	try {
		const email = user.email || "";
		const matchedUser = authenticatedUsers.find((u) => u.email === email);
		localStorage.setItem(
			LS_KEY,
			JSON.stringify({
				...user,
				displayName: matchedUser?.displayName || "Unknown User",
			}),
		);
	} catch {
		// storage quota exceeded — fail silently
	}
};

const clearLocalStorage = () => {
	try {
		localStorage.removeItem(LS_KEY);
	} catch {
		// ignore
	}
};

export const loadUserFromLocalStorage = () => {
	try {
		const raw = localStorage.getItem(LS_KEY);
		return raw ? JSON.parse(raw) : null;
	} catch {
		return null;
	}
};

// ─── Initial state ────────────────────────────────────────────────────────────

const initialState = {
	user: loadUserFromLocalStorage(), // hydrate from localStorage on app start
	loading: false, // login request in flight
	initializing: true, // Firebase onAuthStateChanged not yet fired
	error: null,
};

// ─── Slice ─────────────────────────────────────────────────────────────────────

const authSlice = createSlice({
	name: "auth",
	initialState,
	reducers: {
		/** Called when Firebase onAuthStateChanged fires (app startup). */
		authStateResolved(state, action) {
			state.user = action.payload; // null or serialized user
			state.initializing = false;
			if (action.payload) {
				saveToLocalStorage(action.payload);
			} else {
				clearLocalStorage();
			}
		},

		/** Login request started. */
		loginStart(state) {
			state.loading = true;
			state.error = null;
		},

		/** Login succeeded. */
		loginSuccess(state, action) {
			state.loading = false;
			state.user = {
				...action.payload,
				displayName: authenticatedUsers.find(
					(u) => u.email === action.payload.email,
				)?.displayName,
			};

			state.error = null;
			saveToLocalStorage(action.payload);
		},

		/** Login failed. */
		loginFailure(state, action) {
			state.loading = false;
			state.error = action.payload;
		},

		/** User logged out — wipe everything. */
		logoutSuccess(state) {
			state.user = null;
			state.loading = false;
			state.error = null;
			clearLocalStorage();
		},

		/** Clear any auth error (e.g. when the user starts typing again). */
		clearAuthError(state) {
			state.error = null;
		},
	},
});

export const {
	authStateResolved,
	loginStart,
	loginSuccess,
	loginFailure,
	logoutSuccess,
	clearAuthError,
} = authSlice.actions;

// ─── Selectors ─────────────────────────────────────────────────────────────────

export const selectUser = (state) => state.auth.user;
export const selectIsAuthenticated = (state) => !!state.auth.user;
export const selectAuthLoading = (state) => state.auth.loading;
export const selectAuthError = (state) => state.auth.error;
export const selectAuthInitializing = (state) => state.auth.initializing;

export default authSlice.reducer;
